export default "__VITE_ASSET__BBXIS18z__"